import Component from 'inferno-component';
import Statistics from '../statistics/Statistics';
import { Grid, Container } from  'semantic-ui-react';

export default class Cover extends Component {
  render() {
    return (
      <div id="cover" style={{backgroundImage: 'url("assets/images/cover/cover.jpg")', backgroundSize: 'cover'}}>
        <Grid style={{minHeight: '100vh'}}>
          <Grid.Row>
            <Grid.Column verticalAlign='middle'>
              <Container>
                <Statistics />
              </Container>
            </Grid.Column>
          </Grid.Row>
        </Grid>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/cover/Cover.js